import React from 'react';
import { motion } from 'framer-motion';
interface CardProps {
  children: React.ReactNode;
  featured?: boolean;
  className?: string;
  delay?: number;
}
export function Card({
  children,
  featured = false,
  className = '',
  delay = 0
}: CardProps) {
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    amount: 0.01
  }} transition={{
    duration: 0.5,
    delay
  }} className={`
        rounded-[16px] border-[2px] p-8 sm:p-10
        ${featured ? 'border-border-strong bg-[rgba(250,255,0,0.05)]' : 'border-border bg-gradient-to-b from-[rgba(255,255,255,0.04)] to-[rgba(255,255,255,0.015)]'}
        ${className}
      `} data-id="element-184">
      {children}
    </motion.div>;
}